import Loading from 'components/Loading';
import Select from 'components/Select';
import { Map } from 'immutable';
import { values } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './TaxAuthoritySelectBlock.module.scss';
import { ReactComponent as WarningIcon } from 'components/InfoMessage/assets/ic_warning.svg';

export default class TaxAuthoritySelectBlock extends Component {
  static propTypes = {
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSelect: PropTypes.func.isRequired,
    taxAuthorities: PropTypes.instanceOf(Map).isRequired,
    getTaxAuthorities: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    noResultsMessage: PropTypes.string,
    selectedTaxAuthority: PropTypes.object,
    hasEmptyValue: PropTypes.bool,
  };

  static defaultProps = {
    parentId: null,
    selectedTaxAuthority: null,
    hasEmptyValue: false,
  };

  componentDidMount() {
    const { getTaxAuthorities, parentId } = this.props;

    if (!this.getData()) {
      getTaxAuthorities(parentId);
    }
  }

  componentDidUpdate({ parentId: prevParentId }) {
    const { parentId, taxAuthorities, getTaxAuthorities } = this.props;

    if (parentId !== prevParentId && !taxAuthorities.getIn(['data', parentId])) {
      getTaxAuthorities(parentId);
    }
  }

  getData = () => {
    const { taxAuthorities, parentId } = this.props;
    return parentId ? taxAuthorities.getIn(['data', `${parentId}`]) : taxAuthorities.get('data');
  };

  getTaxAuthoritiesOptions = () => {
    const { parentId, hasEmptyValue, placeholder } = this.props;
    const data = this.getData();
    let taxAuthorities = data.toJS ? values(data.toJS()) : data;
    let options = [];

    if (parentId) {
      taxAuthorities = taxAuthorities.sort((taxAuthority1, taxAuthority2) => {
        const codeDiff = taxAuthority1.codeSOUN - taxAuthority2.codeSOUN;
        return codeDiff > 0 ? 1 : -1;
      });
    }

    if (hasEmptyValue && taxAuthorities.length) {
      options.push({ label: placeholder, value: '-1' });
    }

    const taxAuthorityOptions = taxAuthorities.map((taxAuthority) => {
      const labelToSearch = parentId
        ? `${taxAuthority.codeSOUN} – ${taxAuthority.name}`
        : taxAuthority.name;
      const label = (
        <div className={taxAuthority.visible === false ? styles.disabled : ''}>
          {taxAuthority.visible === false && (
            <span className={styles.icon}>
              <WarningIcon />
            </span>
          )}
          <span> {labelToSearch} </span>
        </div>
      );
      return {
        value: taxAuthority.id,
        label,
        labelToSearch,
      };
    });

    taxAuthorities.length && options.push(...taxAuthorityOptions);

    return options;
  };

  onSelectTaxAuthority = (event) => {
    const { onSelect } = this.props;
    const value = event.value;
    let taxAuthority = value;

    if (~value) {
      const data = this.getData();
      taxAuthority = data.toJS
        ? data.get(`${value}`)
        : data.find((taxAuthority) => taxAuthority.id === value);
    }

    onSelect(taxAuthority);
  };

  isLoading = () => {
    const { taxAuthorities } = this.props;
    return taxAuthorities.get('loading');
  };

  customFilter = (options, filter) => {
    if (!options || !options.length) {
      return [];
    }
    if (!filter) {
      return options;
    }
    return options.filter((option) =>
      option.labelToSearch.toLowerCase().includes(filter.toLowerCase()),
    );
  };

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__big">
        <Loading />
      </div>
    );
  };

  renderSelect = () => {
    if (!this.getData()) {
      return null;
    }
    const { selectedTaxAuthority, label, placeholder, noResultsMessage } = this.props;
    const options = this.getTaxAuthoritiesOptions();
    const needRender = (!options.length && noResultsMessage) || options.length;

    return needRender ? (
      <Select
        label={label}
        options={options}
        value={selectedTaxAuthority ? selectedTaxAuthority.id : null}
        placeholder={placeholder}
        onChange={this.onSelectTaxAuthority}
        isFull={true}
        withoutHelpWrapper={true}
        noResultsMessage={noResultsMessage}
        filterOptions={this.customFilter}
      />
    ) : null;
  };

  render() {
    return this.isLoading() ? this.renderLoading() : this.renderSelect();
  }
}
